<template>
  <div class="wrapp">
    <div class="bg2"></div>
    <div class="bady">
      <div class="bg"></div>
      <div class="cout flex flex-direction justify-center">
        <div>
          <img class="headUrl" src alt />
        </div>
        <div style="margin-top:23px">
          <div class="title">所有美好的足迹，都被记录在这里</div>
          <div class="sub-title">All the beautiful footprints are recorded here</div>
        </div>
        <div>
          <input type="text" placeholder="输入提取码(123)" v-model="inviteCode" />
          <input type="button" value="确认登陆" @click="submitCode" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      inviteCode: null
    };
  },
  methods: {
    submitCode() {
      if (this.inviteCode) {
        if (this.inviteCode == "123") {
          this.$store.commit("setInviteCode", this.inviteCode);
          this.$router.push("/");
        } else {
          this.$router.push("/404");
        }
      }
    }
  }
};
</script>

<style lang='scss' scoped>
.wrapp {
  width: 100%;
  height: 100vh;
  background: url("../assets/img/bg.jpg") no-repeat center center;
  background-size: cover;
  position: relative;
  .bady {
    position: absolute;
    height: 388px;
    width: 655px;
    right: 0;
    top: 50%;
    margin-top: -194px;
    overflow: hidden;
    .cout {
      z-index: 2;
      padding: 30px 40px 30px 200px;
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      .headUrl {
        width: 68px;
        height: 68px;
        background: linear-gradient(
          0deg,
          rgba(25, 145, 235, 1) 0%,
          rgba(46, 161, 248, 1) 100%
        );
        border-radius: 50%;
        display: inline-block;
        border: none;
      }
      .title {
        font-size: 24px;
        font-family: Source Han Sans CN;
        font-weight: 300;
        color: rgba(255, 255, 255, 1);
        line-height: 36px;
      }
      .sub-title {
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: 300;
        color: rgba(255, 255, 255, 1);
        line-height: 28px;
        opacity: 0.6;
      }
      input {
        height: 54px;
        background: rgba(248, 250, 252, 1);
        border: 1px solid rgba(223, 227, 233, 1);
        border-radius: 10px;
        padding: 0 20px;
        display: block;
        width: 420px;
        margin-top: 20px;
        box-sizing: border-box;
        font-size: 16px;
      }
      input[type="button"] {
        background: linear-gradient(
          0deg,
          rgba(57, 181, 74, 1),
          rgba(51, 170, 68, 1)
        );
        border: 1px solid rgba(36, 149, 51, 1);
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        cursor: pointer;
      }
    }
    .bg {
      z-index: 1;
      position: absolute;
      top: 0;
      left: 15%;
      height: 100%;
      width: 90%;
      background: #222531;
      transform: skewX(20deg);
    }
  }
  .bg2 {
    position: fixed;
    top: 0;
    right: -250px;
    height: 100%;
    width: 670px;
    background: rgba(34, 37, 49, 0.22);
    transform: skewX(20deg);
  }
}
</style>